import isEqual from 'react-fast-compare'

/**
 * Compares two objects and checks if at least one of the values of the given properties
 * has changed. Will return false if only one object is passed.
 *
 * Example usage:
 *  const configChanged = havePropertiesChanged(currentFilterConfig, newFilterConfig)
 *  const colorChanged = havePropertiesChanged(currentFilterConfig, newFilterConfig, ['color'])
 *
 * @param {object} firstObject
 * @param {object} secondObject
 * @param {Array[String]} [propertyKeys] Properties of the passed objects that will be compared. Takes keys of first object as fallback.
 * @returns {Boolean} True when at least one value of the given properties is different in the two objects
 */
const havePropertiesChanged = (firstObject, secondObject, propertyKeys) => {
    if (firstObject && secondObject) {
        const keys = propertyKeys || Object.keys(firstObject)
        return keys.some(key => !isEqual(firstObject[key], secondObject[key]))
    }
    return false
}

export { havePropertiesChanged }
